<template>
    <div class='recharge-delivery'>
        <market-title :iconClass="'iconchongzhisong'"
            :title="'充值送'"
            :des="'支持店铺会员充值赠送余额，引导消费者储值'"/>
        <recharge-delivery-table/>
    </div>
</template>

<script lang='ts'>
import { createComponent } from '@vue/composition-api'
import MarketTitle from '../components/market_title.vue'
import RechargeDeliveryTable from './components/recharge_delivery_table.vue'

export default createComponent({
    components: {
        MarketTitle,
        RechargeDeliveryTable
    }
})
</script>
